/* eslint-disable factorial/no-raw-html */
import i18n from 'modules/core/lib/i18n'

import { ScaleType, Scales } from 'modules/documents/components/PdfViewer/types'

import * as styles from './index.vanilla.css'

export interface Props {
  value: ScaleType
  options: Scales[]
  onChange: (value: ScaleType) => void
}

const ScaleSelector = ({ value, options, onChange }: Props) => {
  return (
    <select
      aria-label={i18n.t('documents.viewer.scale_selector')}
      value={value}
      onChange={(event) => {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        const selectedScale = event.target.value as ScaleType
        onChange(selectedScale)
      }}
      className={styles.pdfViewerSelector}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default ScaleSelector
